export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4740.56eb01b9.jpg";